// extracted by mini-css-extract-plugin
export default {"modal":"TermsAndConditions_modal__giw1u"};